export const services = {
  hero: {
    home: 'Accueil',
    services: 'Services',
    title: 'Services Industriels Complets',
    subtitle1: 'Des services d\'expertise technique et de conseil conçus pour optimiser vos processus de filtration et maximiser votre efficacité opérationnelle',
    subtitle2: 'De l\'analyse initiale à l\'optimisation continue, nous fournissons des solutions complètes adaptées à vos besoins industriels spécifiques',
  },
  stats: {
    projectsCompleted: 'Projets Réalisés',
    clientSatisfaction: 'Satisfaction Client',
    technicalSupport: 'Support Technique',
    yearsExperience: 'Années d\'Expérience',
  },
  ourServices: {
    title: 'Nos Services',
    subtitle: 'Une gamme complète de services professionnels pour soutenir vos besoins en filtration et en purification',
    keyDeliverables: 'Livrables Clés :',
    requestService: 'Demander ce Service',
  },
  services: {
    needsAnalysis: {
      title: 'Analyse des Besoins & Applications Industrielles',
      description: 'Évaluation complète de vos processus industriels, exigences et défis pour identifier les solutions de filtration optimales.',
      deliverable1: 'Analyse du flux de processus',
      deliverable2: 'Évaluation des besoins',
      deliverable3: 'Étude de faisabilité technique',
      deliverable4: 'Analyse coût-bénéfice',
      deliverable5: 'Recommandations de solutions',
    },
    technicalConsulting: {
      title: 'Conseil Technique en Filtration & Purification',
      description: 'Conseils d\'experts sur les technologies de filtration, le choix d\'équipements et l\'optimisation des processus par des ingénieurs expérimentés.',
      deliverable1: 'Orientation sélection technologique',
      deliverable2: 'Spécifications des équipements',
      deliverable3: 'Optimisation des performances',
      deliverable4: 'Support conformité réglementaire',
      deliverable5: 'Mise en œuvre des meilleures pratiques',
    },
    processOptimization: {
      title: 'Optimisation des Processus Industriels',
      description: 'Amélioration systématique des systèmes de filtration existants pour renforcer l\'efficacité, réduire les coûts et améliorer la qualité des produits.',
      deliverable1: 'Audits de performance',
      deliverable2: 'Améliorations d\'efficacité',
      deliverable3: 'Stratégies de réduction des coûts',
      deliverable4: 'Amélioration de la qualité',
      deliverable5: 'Optimisation opérationnelle',
    },
    equipmentIntegration: {
      title: 'Sélection & Intégration des Équipements',
      description: 'Assistance professionnelle pour sélectionner et intégrer les bons équipements de filtration pour vos applications spécifiques.',
      deliverable1: 'Évaluation des équipements',
      deliverable2: 'Support sélection fournisseurs',
      deliverable3: 'Planification de l\'intégration',
      deliverable4: 'Supervision de l\'installation',
      deliverable5: 'Support mise en service',
    },
    customerSupport: {
      title: 'Assistance Technique & Support Client',
      description: 'Support technique continu et dépannage pour assurer des performances optimales et minimiser les temps d\'arrêt.',
      deliverable1: 'Hotline technique 24h/24',
      deliverable2: 'Diagnostics à distance',
      deliverable3: 'Support sur site',
      deliverable4: 'Assistance dépannage',
      deliverable5: 'Réponse aux urgences',
    },
    customizedSolutions: {
      title: 'Solutions Personnalisées par Industrie',
      description: 'Solutions de filtration sur mesure conçues spécifiquement pour les exigences de votre industrie et vos contraintes opérationnelles.',
      deliverable1: 'Conception de système personnalisé',
      deliverable2: 'Solutions spécifiques à l\'application',
      deliverable3: 'Programmes de test pilote',
      deliverable4: 'Support de mise à l\'échelle',
      deliverable5: 'Validation des performances',
    },
  },
  process: {
    title: 'Notre Processus de Service',
    subtitle: 'Une approche structurée pour fournir des résultats exceptionnels et un succès durable',
    step1Title: 'Consultation Initiale',
    step1Desc: 'Discutez de vos besoins, défis et objectifs avec notre équipe technique',
    step2Title: 'Analyse & Évaluation',
    step2Desc: 'Évaluation complète de vos processus et identification des solutions optimales',
    step3Title: 'Conception de la Solution',
    step3Desc: 'Développement de spécifications personnalisées et de recommandations',
    step4Title: 'Mise en Œuvre',
    step4Desc: 'Approvisionnement, installation et support de mise en service',
    step5Title: 'Support Continu',
    step5Desc: 'Assistance technique continue, optimisation et surveillance des performances',
    readyToStart: 'Prêt à démarrer votre projet d\'optimisation de filtration ?',
    beginProject: 'Démarrer Votre Projet',
  },
  caseStudies: {
    title: 'Histoires de Succès',
    subtitle: 'Des résultats concrets démontrant notre engagement envers le succès client et l\'excellence technique',
    challenge: 'Défi',
    solution: 'Solution',
    results: 'Résultats Obtenus',
    testimonial: 'Témoignage',
    case1: {
      industry: 'Agroalimentaire & Boissons',
      tag: 'Clarification de Boissons',
      title: 'Optimisation de la Production de Jus',
      challenge: 'Un grand fabricant de jus faisait face à une clarté de produit inconsistante et à une consommation élevée de média filtrant, entraînant des coûts accrus et des variations de qualité.',
      solution: 'Mise en place d\'un système avancé de filtration en profondeur avec une sélection optimisée de média filtrant et de paramètres de processus, incluant un contrôle et une surveillance automatisés.',
      result1: 'Réduction de 40% des coûts de média filtrant',
      result2: 'Amélioration de 95% de la clarté du produit',
      result3: 'Augmentation de 25% du rendement de production',
      result4: 'Réduction de 60% des temps d\'arrêt',
      testimonial: "L'expertise technique de Ste EINA Ltd a transformé notre processus de filtration. Les résultats ont dépassé nos attentes, et leur support continu a été inestimable.",
      client: 'Directeur de Production, Grand Fabricant de Jus',
    },
    case2: {
      industry: 'Pharmaceutique',
      tag: 'Filtration Stérile',
      title: 'Amélioration de la Purification API',
      challenge: 'Une entreprise pharmaceutique nécessitait une amélioration de la filtration stérile pour la production de principes actifs, tout en maintenant la conformité GMP et en réduisant le temps de validation.',
      solution: "Conception et mise en œuvre d'un système de filtration stérile validé utilisant une technologie membranaire de qualité pharmaceutique avec documentation complète et protocoles de test.",
      result1: 'Assurance stérilité de 99,99% atteinte',
      result2: 'Réduction de 50% du temps de validation',
      result3: 'Conformité GMP totale maintenue',
      result4: 'Augmentation de 30% du rendement par lot',
      testimonial: "La compréhension de l'équipe des exigences pharmaceutiques et des normes réglementaires était exceptionnelle. Ils ont livré une solution qui répond à tous nos critères stricts.",
      client: 'Directeur Qualité, Fabricant Pharmaceutique',
    },
    case3: {
      industry: 'Traitement de l\'Eau',
      tag: 'Filtration à Membrane',
      title: 'Purification Eau Municipale',
      challenge: 'Une station de traitement des eaux municipale devait moderniser une infrastructure de filtration vieillissante pour répondre aux nouvelles normes de qualité, tout en gérant des contraintes budgétaires.',
      solution: "Mise en œuvre d'un système de filtration à membrane rentable avec une conception modulaire, permettant une installation progressive et l'intégration avec l'infrastructure existante.",
      result1: "Qualité de l'eau dépassant les normes de 20%",
      result2: 'Réduction de 35% de l\'utilisation de produits chimiques',
      result3: 'Coûts opérationnels inférieurs de 45%',
      result4: 'Durée de vie des équipements prolongée',
      testimonial: 'EINA a fourni une solution pratique qui répondait à nos exigences techniques et budgétaires. Les performances du système ont été remarquables.',
      client: 'Ingénieur en Chef, Autorité Municipale des Eaux',
    },
  },
};